import { useContext, useMemo } from 'react';
import { MeContext } from '../../../context/MeContext';
import { ANNOUNCEMENTS, type AnnouncementConfig } from './announcementConfig';

const SEEN_KEY = (accountId: string, announcementId: string) =>
  `announcement_seen_${accountId}_${announcementId}`;

const wasSeen = (accountId: string, announcementId: string): boolean => {
  try {
    return localStorage.getItem(SEEN_KEY(accountId, announcementId)) === '1';
  } catch {
    return false;
  }
};

export const markSeen = (accountId: string, announcementId: string): void => {
  try {
    localStorage.setItem(SEEN_KEY(accountId, announcementId), '1');
  } catch {
  }
};

export const markAllSeen = (accountId: string): void => {
  ANNOUNCEMENTS.forEach((a) => markSeen(accountId, a.id));
};

const isExpired = (expiresAt: string): boolean =>
  new Date(expiresAt) < new Date();

export const useAnnouncementModals = (): {
  accountId: string | undefined;
  announcements: AnnouncementConfig[];
} => {
  const meCtx = useContext(MeContext) as {
    state: {
      account?: { id?: string | number } | null;
      expressivePassRolloutEnabled?: boolean;
      [key: string]: unknown;
    };
  } | undefined;

  const accountId =
    meCtx?.state?.account?.id != null
      ? String(meCtx.state.account.id)
      : undefined;

  const flagEnabled = !!meCtx?.state?.expressivePassRolloutEnabled;
  const state = meCtx?.state;

  const announcements = useMemo(() => {
    if (!accountId || !flagEnabled) return [];
    return ANNOUNCEMENTS.filter((a) => {
      if (isExpired(a.expiresAt) || wasSeen(accountId, a.id)) return false;
      if (a.featureFlag && !state?.[a.featureFlag]) return false;
      return true;
    });
  }, [accountId, flagEnabled, state]);

  return { accountId, announcements };
};
